import React from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  useTheme,
  alpha,
} from "@mui/material";
import { AccountBalance as AccountBalanceIcon } from "@mui/icons-material";

import { PayoutForm } from "components/Profile/payout-form";

const RegisterBankInitial = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: 4,
        pb: 8,
      }}
    >
      <Container maxWidth="md">
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 4,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: 3,
                bgcolor: "primary.main",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: `0 4px 14px ${alpha(
                  theme.palette.primary.main,
                  0.4,
                )}`,
              }}
            >
              <AccountBalanceIcon sx={{ fontSize: 28, color: "white" }} />
            </Box>
            <Box>
              <Typography variant="h4" fontWeight={700} color="text.primary">
                A Few More Steps...
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Link your bank account to start receiving payments
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* Content */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            border: `1px solid ${theme.palette.divider}`,
            overflow: "hidden",
            p: 3,
          }}
        >
          {/* No JoyThemeProvider here: PayoutForm uses the Material useTheme,
              and wrapping it in Joy's CssVarsProvider hands it the Joy theme —
              palette.primary.main comes back undefined and alpha() throws.
              SettingsPage renders PayoutForm bare for the same reason. */}
          <PayoutForm />
        </Paper>
      </Container>
    </Box>
  );
};

export default RegisterBankInitial;
